/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { isEmpty } from "lodash";
import * as Config from "./config";

async function reqBienesSearch(params, token) {
  params = !isEmpty(params) ? "?" + params : "";
  const tkn = "Bearer " + token;
  const API_URI_ALL_INMUEBLES = Config.rutas.bienes + params;
  try {
    const response = await axios.get(API_URI_ALL_INMUEBLES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllProvincias(token) {
  const API_URI_ALL_PROVINCES = Config.rutas.provincias;
  const tkn = "Bearer " + token;

  try {
    const response = await axios.get(API_URI_ALL_PROVINCES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllServicios(token) {
  const API_URI_ALL_SERVICES = Config.rutas.servicios;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_ALL_SERVICES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllSucursales(token) {
  const API_URI_ALL_SUCURSALES = Config.rutas.sucursales;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_ALL_SUCURSALES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllTiposConvenios(token) {
  const API_URI_ALL_CONTRACT_TYPES = Config.rutas.tiposconvenios;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_ALL_CONTRACT_TYPES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllConvenios(token) {
  const API_URI_ALL_CONTRACT = Config.rutas.convenios;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_ALL_CONTRACT, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllCantones(token) {
  const API_URI_ALL_CANTONES = Config.rutas.cantones;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_ALL_CANTONES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllDistritos(token) {
  const API_URI_ALL_DISTRITOS = Config.rutas.distritos;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_ALL_DISTRITOS, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqTipoBien(token) {
  const API_URI_TIPO_BIEN = Config.rutas.tipobien;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_TIPO_BIEN, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqConveniosTiles(token) {
  const API_URI_CONVENIOS_TILES = Config.rutas.conveniosTiles;
  const tkn = "Bearer " + token;
  try {
    const response = await axios.get(API_URI_CONVENIOS_TILES, {
      headers: { Authorization: tkn, ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export default {
  reqAllProvincias,
  reqAllServicios,
  reqAllSucursales,
  reqAllTiposConvenios,
  reqAllConvenios,
  reqAllCantones,
  reqAllDistritos,
  reqBienesSearch,
  reqTipoBien,
  reqConveniosTiles,
};
